import { Font, StyleSheet } from '@react-pdf/renderer';

const handwriting = 'Great Vibes';

Font.register({
  family: handwriting,
  fonts: [{ src: '/fonts/GreatVibes-Regular.ttf' }],
});

const ink = '#202124';
const muted = '#5f6368';
const line = '#e8eaed';
const border = '#dadce0';
const signed = '#188038';

const styles = StyleSheet.create({
  page: {
    paddingTop: 36,
    paddingBottom: 40,
    paddingLeft: 40,
    paddingRight: 40,
  },
  title: {
    fontSize: 18,
    fontWeight: 500,
    color: ink,
    marginBottom: 16,
  },
  card: {
    borderWidth: 1,
    borderColor: border,
    borderRadius: 8,
    marginBottom: 16,
    overflow: 'hidden',
  },
  sectionTitle: {
    fontSize: 13,
    fontWeight: 500,
    color: ink,
    paddingTop: 12,
    paddingBottom: 10,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: line,
  },
  detailRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 11,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: line,
  },
  detailRowLast: {
    borderBottomWidth: 0,
  },
  detailLabel: {
    width: 132,
    fontSize: 8,
    color: muted,
    letterSpacing: 0.4,
    marginRight: 12,
  },
  detailValue: {
    flex: 1,
    fontSize: 10,
    color: ink,
    lineHeight: 1.4,
  },
  stampColumn: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  stampColumnRight: {
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  stampValue: {
    fontSize: 10,
    color: ink,
  },
  stampTime: {
    marginTop: 4,
  },
  statusValue: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  statusDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: signed,
    marginRight: 6,
  },
  statusText: {
    fontSize: 10,
    color: ink,
  },
  activityRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    paddingVertical: 12,
    paddingHorizontal: 12,
    borderBottomWidth: 1,
    borderBottomColor: line,
  },
  activityIcon: {
    width: 68,
    alignItems: 'center',
    marginRight: 6,
  },
  activityLabel: {
    marginTop: 3,
    fontSize: 7,
    color: muted,
    letterSpacing: 0.3,
  },
  activityBody: {
    flex: 1,
    paddingRight: 10,
    paddingTop: 1,
  },
  bodyText: {
    fontSize: 10,
    color: ink,
    lineHeight: 1.4,
  },
  emphasis: {
    fontWeight: 700,
  },
  recipient: {
    flexDirection: 'row',
    marginTop: 2,
    paddingLeft: 2,
  },
  bullet: {
    fontSize: 10,
    color: ink,
    marginRight: 4,
    lineHeight: 1.4,
  },
  stamp: {
    width: 88,
    alignItems: 'flex-end',
    paddingTop: 1,
  },
  stampText: {
    fontSize: 9,
    color: ink,
    textAlign: 'right',
  },
  disclaimer: {
    fontSize: 8,
    color: muted,
    lineHeight: 1.45,
  },
  signatureBlock: {
    marginTop: 28,
    alignSelf: 'flex-end',
    alignItems: 'flex-start',
  },
  signatureLabel: {
    fontSize: 9,
    color: muted,
    marginBottom: 4,
    textAlign: 'left',
  },
  signature: {
    fontFamily: handwriting,
    fontSize: 30,
    color: ink,
    textAlign: 'left',
  },
});

export default styles;
